import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    overdueAlert: {
        id: '_.new_overdue_dashboard.overdue_alert',
        defaultMessage:
            "<strong>Time to get back on track</strong> - you're overdue by <strong>{amount}</strong>"
    }
});
